import React from 'react'

import { times, random } from 'lodash'
import { Box } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  skeletonChip: {
    borderRadius: '32px',
  },
})

const ChipsLoadingSkeleton = () => {
  const classes = useStyles()
  const count = random(12, 20)
  return (
    <Box
      width="100%"
      height="200px"
      display="flex"
      flexWrap="wrap"
      justifyContent="flex-start"
      alignContent="flex-start"
      fontSize="24px"
      aria-label="loading options"
    >
      {times(count, (idx) => {
        const width = random(90, 125)
        return (
          <Box
            key={idx}
            m={0.5}
            display="inline-block"
            role="progressbar"
          >
            <Skeleton
              variant="rect"
              width={width}
              height={40}
              animation="wave"
              className={classes.skeletonChip}
            />
          </Box>
        )
      })}
    </Box>
  )
}

export default ChipsLoadingSkeleton
